import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Row, Col, Button } from 'react-bootstrap5';
import axios from 'axios';

import routes from 'app/routes';

import { Formik, Form as FormikForm } from 'formik';
import SubmitButton from 'components/Widgets/SubmitButton';
import HorizontalTextField from 'components/new_ui/Form/HorizontalTextField';
import HorizontalSelectRadioField from 'components/new_ui/Form/HorizontalSelectRadioField';
import Alert from 'components/new_ui/Alerts/alert';
import Emoji from './Emoji';

import Actions from '../Actions';

export default function Feedback({
  step, nextSlide,
}) {
  const [rate, setRate] = useState(0);
  const [loading, setLoading] = useState(false);

  const onSkipClick = () => {
    setLoading(true);

    Actions.skip('session_feedback', [step.id], () => {
      setLoading(false);
      nextSlide();
    });
  };

  const onSubmitHundler = (values, { setSubmitting }) => {
    if (rate === 0) {
      Alert({
        text: "We'd love to know what you think! Please select an emoji before proceeding to the next step.",
      });

      setSubmitting(false);
      return;
    }

    axios
      .post(routes.api.steps.session.feedback(step.step.id), {
        session_feedback: {
          rate,
          comment: values.comment,
          useful_module: values.usefull,
        },
      })
      .then((_resp) => {
        nextSlide();
      });
  };

  return (
    <div>
      <h3>
        How did you feel about the coaching session &apos;
        {step.session_name}
        &apos; with
        coach
        {' '}
        {step.coach}
        {' '}
        ?
      </h3>
      <p className="mt-3 mb-3">
        Please select the emoji that represents the best your reaction after the
        session.
      </p>
      <Emoji selectedPosition={rate} setRate={setRate} />
      <Formik
        initialValues={{
          comment: '',
          usefull: null,
        }}
        onSubmit={onSubmitHundler}
      >
        {({ isSubmitting }) => (
          <FormikForm className="needs-validation" noValidate="">
            <Row>
              <Col>
                <HorizontalTextField
                  as="textarea"
                  name="comment"
                  placeholder="Private Comment"
                  rows="4"
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <HorizontalSelectRadioField
                  id="usefull"
                  name="v"
                  label={`Did you find your session about ${step.session_name} useful?`}
                  wrapperClassName="text-center"
                  optionClassName="form-check-inline"
                  collection={[
                    { value: true, label: 'Yes' },
                    { value: false, label: 'No' },
                  ]}
                />
              </Col>
            </Row>

            <footer className="d-flex justify-content-between">
              <Button
                variant="outline-primary"
                onClick={onSkipClick}
                disabled={loading || isSubmitting}
              >
                Skip
              </Button>
              <SubmitButton loading={loading || isSubmitting}>
                Next
              </SubmitButton>
            </footer>

          </FormikForm>
        )}
      </Formik>
    </div>
  );
}

Feedback.propTypes = {
  step: PropTypes.object.isRequired,
  nextSlide: PropTypes.func.isRequired,
};
